module.exports = __webpack_public_path__ + "img/Juli.2049f6c8.jpg";